// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"042bb37f","667":"9ff18320"}[chunkId] + ".chunk.js";
};